import { render } from "./ReviewBlock.vue?vue&type=template&id=0f460449&scoped=true"
import script from "./ReviewBlock.vue?vue&type=script&lang=js"
export * from "./ReviewBlock.vue?vue&type=script&lang=js"

import "./ReviewBlock.vue?vue&type=style&index=0&id=0f460449&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f460449"]])

export default __exports__